export class TimeZone {
    Code: string;
    Name: string;
    Location: string;
    Offset: string;
}